import { IAppDataLoader, IAppInitParams } from "app/model"
import { sspRPO } from "ssp/repository"

export const sspDataLoader: IAppDataLoader = async (params: IAppInitParams, onFinish: (error?: string) => any) => {
  try {
    const ssps = await sspRPO.getAllSsps()
    params.ssps = ssps
    onFinish()
  } catch (error) {
    console.error(error)
    onFinish(`Ssp data-loader error ${String(error)}`)
  }
}
